<template>
	<div :class="'checkbox ' + checkboxStyle">
		<label>
			<input type="checkbox"
				:disabled="disabled"
				:checked="value"
				v-on="listeners"
			/>
			<i class="input-helper"/>
			<span v-if="!disabled" v-html="label">{{ label }}</span>
			<span v-else class="disabled-checkbox" v-html="label">{{ label }}</span>
		</label>
	</div>
</template>

<script>
export default {
	props: {
		label: {
			type: String,
			default: 'label'
		},
		disabled: {
			type: Boolean,
			default: false
		},
		checkboxStyle: {
			type: String,
			default: ''
		},
		value: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		listeners() {
			var vm = this
			return Object.assign(
				{},
				this.$listeners,
				{
					input: function(event) {
						vm.$emit('input', event)
					}
				}
			)
		}
	}
}
</script>

<style lang="scss">
.checkbox {
	position: relative;
	margin-bottom: 5px;
	outline: none;

	label {
		padding-left: 20px;
		display: block;
		cursor: pointer;
		user-select: none;


	}
	input {
		top: 0px;
		left: 0px;
		z-index: 1;
		cursor: pointer;
		opacity: 0;
		position: absolute;
		margin: 1px;
	}

	.input-helper:before,
	.input-helper:after {
		position: absolute;
		content: "";
		transition: all 200ms;
	}
	.input-helper:before {
		left: 0;
		border: 1px solid #7a7a7a;
	}
	input:checked + .input-helper:after {
		transform: scale(1);
		opacity: 1;
	}
	.input-helper:before {
		top: 0;
		width: 12px;
		height: 12px;
		border-radius: 2px;
		color: #fff;
	}
	.input-helper:after {
		background: #4ba98b;
		left: 3px;
		top: 3px;
		width: 8px;
		height: 8px;
		opacity: 0;
	}
}
.disabled-checkbox {
	color: #7b7b7b;
}

// register-checkbox style
.checkbox.register-checkbox {
	.input-helper:before {
		border: 1px solid #fff;
	}
	.input-helper:before {
		border-radius: 0;
		background-color: #e8e6dd;
	}
}

</style>
